module.exports = __webpack_public_path__ + "img/logo.f51bcd89.svg";